// Port Radar Dashboard & Map JS
// Loaded via application.js pack on any page that includes it.

window.PortRadar = (function () {
  'use strict';

  // ─── Guest timer config ───────────────────────────────────────────────
  // Change this value to adjust how long (seconds) a guest can browse
  // before the sign-up popup appears.
  var GUEST_TIMER_SECONDS = 30;

  // ─── Colour helpers ──────────────────────────────────────────────────
  var STATUS_COLORS = {
    suspended: '#E53935',
    congested: '#FFA726',
    normal:    '#43A047'
  };

  // ─── Dashboard ───────────────────────────────────────────────────────
  function initDashboard() {
    bindRefreshButton();
    bindCountryFilters();
    startPolling();
    startGuestTimer();
  }

  function bindRefreshButton() {
    var btn = document.getElementById('pr-refresh-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var url     = btn.dataset.url;
      var label   = btn.querySelector('.pr-refresh-label');
      var spinner = btn.querySelector('.pr-refresh-spinner');

      btn.disabled = true;
      label.classList.add('d-none');
      spinner.classList.remove('d-none');

      fetch(url, {
        method:      'POST',
        headers:     { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
        credentials: 'same-origin'
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          resetButton(btn, label, spinner);
          if (data.queued) {
            showRefreshNotice('🔄 Fetching port data in background — page will update automatically.');
          }
        })
        .catch(function () {
          resetButton(btn, label, spinner);
          showRefreshNotice('❌ Failed to queue refresh. Please try again.', true);
        });
    });
  }

  function resetButton(btn, label, spinner) {
    btn.disabled = false;
    label.classList.remove('d-none');
    spinner.classList.add('d-none');
  }

  function showRefreshNotice(message, isError) {
    var existing = document.getElementById('pr-notice');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.id = 'pr-notice';
    el.textContent = message;
    el.style.cssText = [
      'position:fixed', 'bottom:24px', 'right:24px', 'z-index:9999',
      'background:' + (isError ? '#E53935' : '#212121'),
      'color:#fff',
      'padding:11px 18px',
      'border-radius:8px',
      'font-size:13px',
      'font-weight:600',
      'box-shadow:0 4px 16px rgba(0,0,0,0.2)',
      'max-width:340px',
      'line-height:1.45',
      'transition:opacity 0.3s ease',
      'opacity:0'
    ].join(';');

    document.body.appendChild(el);

    // Fade in
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.style.opacity = '1'; });
    });

    // Auto-dismiss after 6s
    setTimeout(function () {
      el.style.opacity = '0';
      setTimeout(function () { el.parentNode && el.parentNode.removeChild(el); }, 350);
    }, 6000);
  }

  // ─── Polling ─────────────────────────────────────────────────────────
  // Polls /port-radar/status every 5 minutes.
  // If last_updated has changed since page load, reloads the page.
  function startPolling() {
    var stateEl = document.getElementById('pr-last-updated');
    if (!stateEl) return;

    var knownTimestamp = stateEl.dataset.timestamp || '';
    var pollUrl        = stateEl.dataset.pollUrl;

    setInterval(function () {
      fetch(pollUrl, { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.last_updated && data.last_updated !== knownTimestamp) {
            window.location.reload();
          }
        })
        .catch(function () { /* silent — try again next interval */ });
    }, 5 * 60 * 1000); // every 5 minutes
  }

  function bindCountryFilters() {
    var filterBtns    = document.querySelectorAll('.port-radar__filter-btn');
    var counterCards  = document.querySelectorAll('.port-radar__counter[data-status-filter]');
    var rows          = document.querySelectorAll('#pr-tbody .pr-row');

    // Track active filters independently
    var activeCountry = 'all';
    var activeStatus  = 'all';

    function applyFilters() {
      rows.forEach(function (row) {
        var countryMatch = activeCountry === 'all' || row.dataset.country === activeCountry;
        var statusMatch  = activeStatus  === 'all' || row.dataset.status  === activeStatus;
        row.style.display = (countryMatch && statusMatch) ? '' : 'none';
      });
    }

    // Country tab buttons
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        activeCountry = btn.dataset.filter;
        applyFilters();
      });
    });

    var clearBtn = document.getElementById('pr-clear-status');

    function updateClearButton() {
      if (!clearBtn) return;
      if (activeStatus === 'all') {
        clearBtn.classList.add('d-none');
      } else {
        clearBtn.classList.remove('d-none');
      }
    }

    function resetStatusFilter() {
      activeStatus = 'all';
      counterCards.forEach(function (c) { c.classList.remove('pr-counter--active'); });
      updateClearButton();
      applyFilters();
    }

    counterCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var chosen = card.dataset.statusFilter;
        if (activeStatus === chosen) {
          resetStatusFilter();
        } else {
          activeStatus = chosen;
          counterCards.forEach(function (c) { c.classList.remove('pr-counter--active'); });
          card.classList.add('pr-counter--active');
          updateClearButton();
          applyFilters();
        }
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', resetStatusFilter);
    }
  }

  // ─── Guest signup timer ───────────────────────────────────────────────
  // Shows a blocking signup modal after GUEST_TIMER_SECONDS for guests.
  // Uses localStorage so refreshing the page doesn't reset the clock.
  function startGuestTimer() {
    var el = document.getElementById('pr-guest-gate');
    if (!el) return; // element only rendered for guests by the view

    var STORAGE_KEY = 'pr_guest_first_visit';

    function showGate() {
      el.classList.add('pr-guest-gate--visible');
      document.body.style.overflow = 'hidden';
    }

    var firstVisit = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    var now = Date.now();

    if (!firstVisit) {
      // First visit — record the timestamp
      localStorage.setItem(STORAGE_KEY, now.toString());
      firstVisit = now;
    }

    var elapsed = (now - firstVisit) / 1000; // seconds since first visit

    if (elapsed >= GUEST_TIMER_SECONDS) {
      // Time already expired from a previous visit — show immediately
      showGate();
    } else {
      // Show after remaining time
      var remaining = (GUEST_TIMER_SECONDS - elapsed) * 1000;
      setTimeout(showGate, remaining);
    }
  }

  // ─── Tracking CTA analytics ─────────────────────────────────────────
  function bindTrackingCta() {
    var cta = document.querySelector('.pr-tracking-cta__btn');
    if (!cta) return;

    cta.addEventListener('click', function () {
      // GTM dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'port_pulse_track_shipment_click',
        event_category: 'Port Pulse',
        event_label: 'Track My Shipment CTA'
      });

      // Persist to DB
      fetch('/port-pulse/track-click', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
        credentials: 'same-origin',
        body: JSON.stringify({ event_name: 'track_shipment_click', page: 'map' })
      }).catch(function () { /* fire-and-forget */ });
    });
  }

  // ─── Map ─────────────────────────────────────────────────────────────
  function initMap() {
    bindRefreshButton();
    startGuestTimer();
    bindTrackingCta();

    var el = document.getElementById('pr-map');
    if (!el) return;

    var dataEl = document.getElementById('pr-map-data');
    var ports  = [];
    if (dataEl) {
      try { ports = JSON.parse(dataEl.textContent); } catch (e) { /* empty */ }
    }

    var map = L.map('pr-map', { zoomControl: true, preferCanvas: true }).setView([24, 50], 5);

    // Prefer MapLibre for a modern basemap. Fallback to Carto raster tiles
    // (so it still looks "fresh" instead of default OSM styling).
    var hasMapLibre = (typeof L !== 'undefined' && L.maplibreGL);
    if (hasMapLibre) {
      L.maplibreGL({
        style: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
        attribution: '© OpenStreetMap contributors © CARTO'
      }).addTo(map);
    } else {
      // Light, modern map styling compatible with Leaflet.
      L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; OpenStreetMap contributors &copy; CARTO'
      }).addTo(map);
    }

    var markersByStatus = { suspended: [], congested: [], normal: [] };

    ports.forEach(function (port) {
      if (port.lat == null || port.lng == null) return;

      var marker = L.marker([port.lat, port.lng], {
        icon: buildIcon(port.status),
        title: port.port_name
      }).addTo(map);

      var color       = STATUS_COLORS[port.status] || '#9E9E9E';
      var statusLabel = port.status.toUpperCase();
      var reasonHtml  = port.reason
        ? '<p style="margin:6px 0 0;color:#555;font-size:12px;line-height:1.4;">' + escapeHtml(port.reason) + '</p>'
        : '';

      marker.bindPopup(
        '<div style="min-width:220px;font-family:inherit;padding:2px 0 4px;">' +
          // Port name + country
          '<div style="margin-bottom:8px;">' +
            '<div style="font-size:15px;font-weight:700;color:#212121;line-height:1.3;">' + escapeHtml(port.port_name) + '</div>' +
            '<div style="font-size:12px;color:#9E9E9E;margin-top:2px;">' + escapeHtml(port.country || '') + '</div>' +
          '</div>' +
          // Divider
          '<div style="height:1px;background:#EFEFEF;margin-bottom:10px;"></div>' +
          // Status badge
          '<span style="display:inline-flex;align-items:center;gap:5px;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:700;letter-spacing:0.4px;color:#fff;background:' + color + ';margin-bottom:' + (port.reason ? '10px' : '4px') + ';">' +
            statusIconSvg(port.status) + ' ' + statusLabel +
          '</span>' +
          // Reason
          (port.reason
            ? '<div style="font-size:12px;color:#424242;line-height:1.55;padding:0 0 4px;">' + escapeHtml(port.reason) + '</div>'
            : '') +
        '</div>',
        { maxWidth: 290, className: 'pw-popup' }
      );

      if (markersByStatus[port.status]) {
        markersByStatus[port.status].push(marker);
      }
    });

    // Counter cards filter markers
    var counterCards = document.querySelectorAll('.port-radar__counter[data-status-filter]');
    var clearBtn     = document.getElementById('pr-clear-status');
    var activeStatus = 'all';

    function syncMarkers() {
      ['suspended', 'congested', 'normal'].forEach(function (status) {
        var visible = activeStatus === 'all' || activeStatus === status;
        markersByStatus[status].forEach(function (marker) {
          if (visible) {
            if (!map.hasLayer(marker)) marker.addTo(map);
          } else {
            if (map.hasLayer(marker))  map.removeLayer(marker);
          }
        });
      });
    }

    function updateClearButton() {
      if (!clearBtn) return;
      if (activeStatus === 'all') {
        clearBtn.classList.add('d-none');
      } else {
        clearBtn.classList.remove('d-none');
      }
    }

    function resetStatusFilter() {
      activeStatus = 'all';
      counterCards.forEach(function (c) { c.classList.remove('pr-counter--active'); });
      updateClearButton();
      syncMarkers();
    }

    counterCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var chosen = card.dataset.statusFilter;

        if (activeStatus === chosen) {
          resetStatusFilter();
        } else {
          activeStatus = chosen;
          counterCards.forEach(function (c) { c.classList.remove('pr-counter--active'); });
          card.classList.add('pr-counter--active');
          updateClearButton();
          syncMarkers();
        }
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', resetStatusFilter);
    }
  }

  // Build a custom SVG div-icon for each status
  function buildIcon(status) {
    var color    = STATUS_COLORS[status] || '#9E9E9E';
    var pulse    = status === 'suspended';
    // Pin shape: circle body + downward point, anchor symbol inside
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="44" viewBox="0 0 36 44">' +
        // Drop shadow
        '<filter id="ds" x="-30%" y="-20%" width="160%" height="160%">' +
          '<feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.35)"/>' +
        '</filter>' +
        // Pin body (teardrop)
        '<path d="M18 2 C8.6 2 1 9.6 1 19 C1 29.5 18 42 18 42 C18 42 35 29.5 35 19 C35 9.6 27.4 2 18 2Z" ' +
          'fill="' + color + '" filter="url(#ds)"/>' +
        // White inner circle
        '<circle cx="18" cy="18" r="10" fill="white" opacity="0.95"/>' +
        // Anchor icon (simplified, dark coloured)
        '<text x="18" y="23" text-anchor="middle" font-size="13" fill="' + color + '" font-family="serif">⚓</text>' +
      '</svg>';

    var pulseHtml = pulse
      ? '<span style="position:absolute;top:-4px;left:-4px;width:44px;height:52px;border-radius:50% 50% 40% 40%;border:3px solid ' + color + ';opacity:0.5;animation:pr-pulse 1.4s ease-out infinite;pointer-events:none;"></span>'
      : '';

    return L.divIcon({
      html: '<div style="position:relative;width:36px;height:44px;">' + pulseHtml + svg + '</div>',
      className: 'pr-map-icon pr-map-icon--' + status,
      iconSize:    [36, 44],
      iconAnchor:  [18, 44],
      popupAnchor: [0, -46]
    });
  }

  // Tiny inline SVG dot for the popup badge
  function statusIconSvg(status) {
    var icons = {
      suspended: '⛔',
      congested: '⚠️',
      normal:    '✅'
    };
    return '<span style="font-size:11px;">' + (icons[status] || '') + '</span>';
  }

  // ─── Helpers ─────────────────────────────────────────────────────────
  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  return {
    initDashboard: initDashboard,
    initMap:       initMap
  };
}());
